import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { PDFDocumentProxy } from "pdfjs-dist";

@Component({
  selector: "app-pdfjs-viewer",
  templateUrl: "./pdfjs-viewer.component.html",
})
export class PdfjsViewerComponent implements OnInit {
  @Input() pdfSrc: string;
  @Input() height: number;
  @Input() scale: number;
  @Input() thumbScale: number;
  public hasSidebar: boolean = true;
  public zoom: number = 100;
  @ViewChild("canvas", { static: false })
  public canvas: ElementRef<HTMLCanvasElement>;
  public context: CanvasRenderingContext2D;
  public numPages: number;
  public pageNum: number = 1;
  public pdfDoc: PDFDocumentProxy;
  public pageRendering = false;
  public pageNumPending = null;
  private workerSrc: string =
    "./assets/js/pdf.worker.min.js"; /* 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.5.207/pdf.worker.js'; */
  public thumbsIndexes: number[] = [];
  @ViewChildren("cvs") thumbCanvas: QueryList<ElementRef>;
  @Output() loadComplete: EventEmitter<PDFDocumentProxy> = new EventEmitter();
  @Output() error: EventEmitter<string> = new EventEmitter();
  public isLoaded: boolean = false;
  public onError: boolean = false;
  constructor() { }

  ngOnInit() {
    this.scale = this.scale ? this.scale : 1;
    this.thumbScale = this.thumbScale ? this.thumbScale : 0.5;
    this.loadPdf(this.pdfSrc);
  }

  loadPdf(pdfSrc: string) {
    console.log("START PDF loading");
    PDFJS.workerSrc = this.workerSrc;
    const loadingTask = PDFJS.getDocument(pdfSrc);
    console.log("Loading PDF document");
    loadingTask.then(
      (pdf) => {
        this.isLoaded = true;
        this.pdfDoc = pdf;
        this.numPages = pdf.numPages;
        this.indexTumbs();
        console.log("PDF document loaded");
        console.log("PDF: ", pdf);
        console.log("Numero pagine PDF: " + pdf.numPages);
        this.renderPage(this.pageNum);
        setTimeout(() => this.renderThumbs(), 100);
        this.loadComplete.emit(this.pdfDoc);
      },
      (err) => {
        console.log("Error loadin PDF document: ", err);
        this.onError = true;
        this.error.emit(err);
      }
    );
  }

  renderPage(num: number) {
    console.log("Rendering PDF page");
    this.pageRendering = true;
    this.pdfDoc.getPage(num).then(
      (page) => {
        const viewport = page.getViewport(this.scale);
        // Support HiDPI-screens.
        const outputScale = window.devicePixelRatio || 1;

        const context = this.canvas.nativeElement.getContext("2d");

        this.canvas.nativeElement.width = Math.floor(
          viewport.width * outputScale
        );
        this.canvas.nativeElement.height = Math.floor(
          viewport.height * outputScale
        );
        this.canvas.nativeElement.style.width =
          Math.floor(viewport.width) + "px";
        this.canvas.nativeElement.style.height =
          Math.floor(viewport.height) + "px";

        const transform =
          outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null;

        const renderContext = {
          canvasContext: context,
          transform: transform,
          viewport: viewport,
        };

        const renderTask = page.render(renderContext);
        renderTask.then(() => {
          this.pageRendering = false;
          if (this.pageNumPending !== null) {
            this.renderPage(this.pageNumPending);
            this.pageNumPending = null;
          }
        });
      },
      (err) => {
        console.log("Error rendering PDF page: ", err);
        this.error.emit(err);
      }
    );
  }

  prevPage() {
    if (this.pageNum <= 1) {
      return;
    }
    console.log("PDF prev page");
    this.pageNum--;
    this.queueRenderPage(this.pageNum);
  }

  nextPage() {
    if (this.pageNum >= this.pdfDoc.numPages) {
      return;
    }
    console.log("PDF next page");
    this.pageNum++;
    this.queueRenderPage(this.pageNum);
  }

  page(num: number) {
    if (num == this.pageNum) {
      return;
    }
    console.log("PDF page " + num);
    this.pageNum = num;
    this.queueRenderPage(num);
  }

  queueRenderPage(num: number) {
    if (this.pageRendering) {
      this.pageNumPending = num;
    } else {
      this.renderPage(num);
    }
  }

  indexTumbs() {
    for (let i = 1; i <= this.pdfDoc.numPages; i++) {
      this.thumbsIndexes.push(i);
    }
  }

  renderThumbs() {
    console.log("Rendering PDF thumbs");
    for (const num of this.thumbsIndexes) {
      this.pageRendering = true;
      this.pdfDoc.getPage(num).then(
        (page) => {
          const viewport = page.getViewport(this.thumbScale);
          const context = this.thumbCanvas
            .toArray()
          [num - 1].nativeElement.getContext("2d");
          const renderContext = {
            canvasContext: context,
            viewport: viewport,
          };
          const renderTask = page.render(renderContext);
          renderTask.then(() => {
            this.pageRendering = false;
            if (this.pageNumPending !== null) {
              this.renderPage(this.pageNumPending);
              this.pageNumPending = null;
            }
          });
        },
        (err) => {
          console.log("Error rendering PDF thumbnail page: ", err);
          this.error.emit(err);
        }
      );
    }
  }

  toggleThumbs() {
    this.hasSidebar = this.hasSidebar ? false : true;
    this.scale = this.hasSidebar ? 1 : 1.2;
    this.renderPage(this.pageNum);
  }

  zoomPlus() {
    this.scale += 0.1;
    this.renderPage(this.pageNum);
  }

  zoomMinus() {
    this.scale -= 0.1;
    this.renderPage(this.pageNum);
  }

  zoomReset() {
    if (this.scale === 1) {
      return;
    }
    this.scale = this.hasSidebar ? 1 : 1.2;
    this.renderPage(this.pageNum);
  }
}
